/**
 * ALERT-NOTICE.JS
 */

import Cookies from 'js-cookie';
import Slideable from '../classes/slideable';

const COOKIE_IDENTIFIER = 'alert-noticed';

export default class AlertNotice {

	/**
	 * Initializes the alert notice in the header navigation menu.
	 */
	static init() {
		return new AlertNotice();
	}

	constructor() {
		const mainElement = document.querySelector('#alert-notice');
		const slideableMainElement = new Slideable(mainElement);
	
		if (mainElement === null)
			return;
	
		this.initHeaderToggle(mainElement);
		this.initCloseButton(mainElement, slideableMainElement);
	
		if (Cookies.get(COOKIE_IDENTIFIER) !== 'true') {
			slideableMainElement.toggle();
		}
	}

	
	initCloseButton(alertNoticeElement, slideableAlertNoticeElement) {
		if (alertNoticeElement === null)
			return;

		const closeButton = alertNoticeElement.querySelector('.alert-notice-close-button');

		closeButton.addEventListener('click', () => {
			slideableAlertNoticeElement.up();
			Cookies.set(COOKIE_IDENTIFIER, 'true', {expires: 14});
		});
	}

	initHeaderToggle(alertNoticeElement, slideableAlertNoticeElement) {
		if (alertNoticeElement === null)
			return;

		const navigationElement = document.querySelectorAll('.button-toggle-alert');

		if (navigationElement.length === 0)
			return;

		navigationElement.addEventListener('click', () => {
			slideableAlertNoticeElement.toggle();
			Cookies.set(COOKIE_IDENTIFIER, 'true', {expires: 14});
		});
	}

}